import { DiscountInterface, SaleDiscountsInterface } from "@/interface/business/discount.interface";
import { DiscountType } from "@/types/business/discount.type";
import Discount from "@/modules/business/discount/discount";
import { DISCOUNT_TYPES } from "@/enums/business.enum";

export class SaleDiscounts implements SaleDiscountsInterface {
  list: Array<DiscountInterface> = [];
  length: number = 0;

  constructor(data?: Array<DiscountType>, length: number = 0) {
    if (!data) {
      return;
    }

    this.length = length;
    this.list = data
      .filter((discount) => {
        return !discount?.item_applicable;
      })
      .map((discount) => {
        return new Discount(discount);
      });
  }

  getPackageSaleDiscount(): any {
    // get automatic discount and ignore the scheduled discount are not valid
    const autoDiscount: Array<DiscountInterface> = [];
    const customDiscount: Array<DiscountInterface> = [];
    this.list.forEach((discount) => {
      if (!!discount?.isScheduled && !discount.isValidNow) {
        return;
      }

      if (!!discount?.automatic && !!discount?.is_custom) {
        customDiscount.push(discount);
        return;
      }

      if (!!discount?.automatic) {
        autoDiscount.push(discount);
      }
    });

    // get fixed discount list
    const fixedDiscount = autoDiscount.filter((discount) => discount.type === DISCOUNT_TYPES.FIXED);

    // get percent discount list
    const PercentDiscount = autoDiscount.filter((discount) => discount.type === DISCOUNT_TYPES.PERCENTAGE);

    // select most value in fixed discount
    const selectedDiscountFixed: DiscountInterface = this.getMostAmountDiscount(fixedDiscount);

    // select most value in percent discount
    const selectedDiscountPercent: DiscountInterface = this.getMostRateDiscount(PercentDiscount);

    // return back (without any action) if there is 2 types discount selected
    if (!!selectedDiscountFixed && !!selectedDiscountPercent) {
      return;
    }

    // select fixed if exist
    if (!!selectedDiscountFixed) {
      return selectedDiscountFixed;
    }

    // select percent if exist
    if (!!selectedDiscountPercent) {
      return selectedDiscountFixed;
    }

    if (customDiscount?.length === 1) {
      return customDiscount[0];
    }
    // custom discount implementation
  }

  getMostAmountDiscount(list) {
    return list.reduce((acc, shot) => (acc.amount > shot.amount ? acc : shot), 0) || null;
  }

  getMostRateDiscount(list) {
    return list.reduce((acc, shot) => (acc.rate > shot.rate ? acc : shot), 0) || null;
  }

  updateDiscountList(list: Array<DiscountInterface>): void {
    this.list = [...this.list, ...list];
  }
}
